export interface IAnalytic {
  gaId: string;
}

export const AnalyticsEvent = {
  BUTTON_CLICKED: 'Button Clicked',
  LINK_VISITED: 'Link Visited'
};
